import React from 'react'
import FabricInquiriesDetails from './FabricInquiriesDetails'
import VendorFabricInquiryNewDetails from './VendorFabricInquiryNewDetails'
import VendorFabricInquiriesDetails from './VendorFabricInquiriesDetails'


const VendorFabricInquiriesBody = () => {
    return (
        <div className="view-qualities folded router-view-container">
            <VendorFabricInquiriesDetails/>
        </div>
    )
}

export default VendorFabricInquiriesBody